<app-modal
  [isOpen]="true"
  [title]="'Historial de Observación'"
  [width]="75"
  [height]="92"
  (closeModal)="onClose()"
>
  <div class="history-modal-wrapper flex flex-col gap-6">
    <div class="patient-info-grid">
      <div class="info-item">
        <span class="info-label">Nombre:</span>
        <span class="info-value"
          >{{ observation().patientFirstName }}
          {{ observation().patientLastName }}</span
        >
      </div>
      <div class="info-item">
        <span class="info-label">Documento:</span>
        <span class="info-value"
          >{{ observation().identificationType }}
          {{ observation().identificationNumber }}</span
        >
      </div>
      <div class="info-item">
        <span class="info-label">Código LG:</span>
        <span class="info-value">{{ observation().lgNumber || '-' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Código Patcore:</span>
        <span class="info-value">{{ observation().caseNumber }}</span>
      </div>
    </div>

    <div class="flex justify-end">
      @if (!isResolved()) {
      <app-button
        [label]="showAddForm() ? 'Cancelar' : 'Agregar observación'"
        [type]="
          showAddForm()
            ? ButtonTypeEnum.PRIMARY_OUTLINE
            : ButtonTypeEnum.PRIMARY
        "
        [size]="ButtonSizeEnum.SM"
        (handleClick)="toggleAddForm()"
        [disabled]="isLoading()"
      ></app-button>
      }
    </div>

    <!-- Add observation form -->
    @if (showAddForm()) {
      <div class="add-form flex flex-col gap-3 p-4 rounded-lg">
        <span class="text-sm font-medium text-text-primary"
          >Nueva observación</span
        >
        <textarea
          class="observation-textarea"
          [(ngModel)]="newObservationText"
          placeholder="Escriba la observación de seguimiento..."
          rows="3"
          [disabled]="isSaving()"
        ></textarea>
        <div class="flex justify-end">
          <app-button
            label="Guardar observación"
            [type]="ButtonTypeEnum.PRIMARY"
            [size]="ButtonSizeEnum.SM"
            (handleClick)="onAddObservation()"
            [disabled]="!newObservationText.trim() || isSaving()"
          ></app-button>
        </div>
      </div>
    }

    <!-- History table -->
    @if (isLoading()) {
      <div class="loading-container flex justify-center items-center py-8">
        <span class="text-text-secondary">Cargando historial...</span>
      </div>
    } @else if (historyRecords().length === 0) {
      <div class="empty-state flex flex-col items-center py-8 text-center">
        <i class="icon-documento text-4xl text-text-tertiary mb-2"></i>
        <span class="text-text-secondary">No hay registros de historial</span>
      </div>
    } @else {
      <div class="history-table-scroll">
        <table class="history-table w-full">
          <caption class="sr-only">
            Historial de cambios de la observación
          </caption>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Acción</th>
              <th>Estado</th>
              <th>Observación</th>
            </tr>
          </thead>
          <tbody>
            @for (record of historyRecords(); track record.historyId) {
              <tr>
                <td class="date-cell">
                  {{ record.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                </td>
                <td class="user-cell">
                  {{ record.createdByName || 'Sistema' }}
                </td>
                <td class="action-cell">
                  <span
                    class="action-badge"
                    [ngClass]="getActionClass(record.actionType)"
                  >
                    {{ getActionLabel(record.actionType) }}
                  </span>
                </td>
                <td class="status-cell">
                  {{ record.statusName || '-' }}
                </td>
                <td class="observation-cell">
                  {{ record.observationText || '-' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <div class="flex justify-end gap-4 pt-4 border-t border-gray-200">
      <app-button
        label="Cerrar"
        [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
        [size]="ButtonSizeEnum.MD"
        (handleClick)="onClose()"
      >
      </app-button>
    </div>
  </div>
</app-modal>
